import React, { Fragment } from 'react';
import {
    List,
    ListItem,
    FormGroup,
    ListItemText,
    Typography,
    makeStyles,
    Theme,
    Box,
} from '@material-ui/core';
import { ITemplateList } from './types';
import { NotTemplatesItems } from './NotTemplatesItems';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: 0,
        height: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    list: {
        overflow: 'auto',
        flex: 1,
        maxHeight: '100%',
    },
    marginBottom: {
        marginBottom: '1em',
    },
    listItem: {
        textAlign: 'justify',
        alignItems: 'flex-start',
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    selectedItem: {
        backgroundColor: `${theme.palette.primary.main}15`,
        borderLeft: `3px solid ${theme.palette.primary.main}`,
        '&:hover': {
            backgroundColor: `${theme.palette.primary.main}20`,
        },
    },
    templateListContainer: {
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },
    templateText: {
        whiteSpace: 'pre-wrap',
        overflowWrap: 'anywhere',
        wordBreak: 'break-word',
    },
}));

export const TemplateList = ({
    templates,
    setCurrentTemplate,
    currentTemplate,
    ...props
}: ITemplateList) => {
    const classes = useStyles();
    return (
        <Box className={classes.templateListContainer}>
            <FormGroup className={classes.root} {...props}>
                <List
                    component="nav"
                    aria-label="templates"
                    className={classes.list}
                    data-testid="template-list"
                >
                    {templates.length === 0 && <NotTemplatesItems />}
                    {templates.map((item) => (
                        <ListItem
                            key={item._id}
                            button
                            onClick={() => setCurrentTemplate(item)}
                            data-testid={`template-item-${item._id}`}
                            className={`${classes.listItem} ${
                                currentTemplate?._id === item._id
                                    ? classes.selectedItem
                                    : ''
                            }`}
                        >
                            <ListItemText
                                primary={
                                    <Fragment>
                                        <Typography
                                            variant="h6"
                                            color="textPrimary"
                                            className={`${classes.marginBottom} ${classes.templateText}`}
                                        >
                                            {item.title || item.templateTitle}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            className={classes.templateText}
                                        >
                                            {item.description}
                                        </Typography>
                                    </Fragment>
                                }
                            />
                        </ListItem>
                    ))}
                </List>
            </FormGroup>
        </Box>
    );
};
